import React from 'react';
import AlertBox from '../../../../shared/components/alert/AlertBox';
import { CardCopyIVData } from './CardCopyIVData';
import { Col } from 'react-bootstrap';
import { SuccessToast } from '../../../../utils/toasters';
import { useTranslation } from 'react-i18next';

const InvoiceHeaderComponent = () => {
    const { t } = useTranslation();
    const copyHandler = (link: string) => {
        navigator.clipboard.writeText(link ?? ' ');
        SuccessToast(t('general.button.copied'));
    };

    return (
        <>
            <AlertBox
                image="/icons/img-warning.svg"
                classCol="col-md-9"
                title={t('influencer.offers.invoicing_disclaimer')}
                desc={t(`influencer.offers.invoicing_disclaimer_alert`)}
                classBody="py-2"
            />
            <Col xl={3} md={3} className="mt-3 mt-md-0 ">
                <CardCopyIVData copyHandler={copyHandler} copyText={t('influencer.invoice.invoice_copy_text')} />
            </Col>
        </>
    );
};

export default React.memo(InvoiceHeaderComponent);
